import React, { Component } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";

import servicioHttp from "../servicio/ServicioHttp";
import { Paginator } from 'primereact/paginator';
import servicioFormatos from '../servicio/ServicioFormatos';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import servicioObjetos from '../servicio/ServicioObjetos';
import { Button } from 'primereact/button';
import { DEFAULT_MASKS } from '../servicio/ServicioConstantes';
export class TablaImssTrabajador extends Component {
    constructor() {
        super();
        this.state = {
            desarrollador: false,
            errores: {},
            mostrarModalConfirmacion: false,
            mostrarModalActualizarPatron: false,
            patron: {},
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales: 0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
        }

    }
    componentDidMount() {
        this.obtenerResultados();
        this.obtnerUsuarioDesarrollador();
    }
    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }
    asignar_restricciones = () => {
        let { paginacion } = this.state;
        paginacion.restriccionesDinamicas = [];
    }
    obtenerResultados = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('imss_trabajador/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto })
        }).catch(error => {

        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerResultados();
    }
    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaVigente)}</div>;
    }
    columnaExcedente = (rowData, column) => {
        return <div>{rowData.excedente}%</div>;
    }
    columnaPrestacionDinero = (rowData, column) => {
        return <div>{rowData.prestacionDinero}%</div>;
    }
    columnaGastosMedicosPensionados = (rowData, column) => {
        return <div>{rowData.gastosMedicosPensionados}%</div>;
    }
    columnaInvalidezVida = (rowData, column) => {
        return <div>{rowData.invalidezVida}%</div>;
    }
    columnaCesantiaEdadAvanzadaVejez = (rowData, column) => {
        return <div>{rowData.cesantiaEdadAvanzadaVejez}%</div>;
    }
    guardarPatron = () => {
        let { patron } = this.state;
        servicioHttp.consumirPostHttp('imss_trabajador/guardar.json', patron).then(response => {
            this.setState({ mostrarModalActualizarPatron: false, patron: {} })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se guardo el patron", life: 6000 });
        });

    }
    prepararEditar = (rowData) => {
        let patron = JSON.parse(JSON.stringify(rowData));
        this.setState({ patron: patron, mostrarModalActualizarPatron: true });
    }
    eliminar = () => {
        let { patron } = this.state;
        servicioHttp.consumirPostHttp('imss_trabajador/eliminar.json', patron).then(response => {
            this.setState({ mostrarModalActualizarPatron: false, patron: {}, mostrarModalConfirmacion: false })
            this.obtenerResultados();
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "No se elimino el patron", life: 6000 });
        });
    }

    cerrarModal = () => {
        this.setState({ mostrarModalActualizarPatron: false });
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }
    plantillaOpciones = (rowData, column) => {
        let { desarrollador } = this.state;
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                {desarrollador ?
                    <Button type="button" icon="pi-md-edit" onClick={(e) => this.prepararEditar(rowData)}
                        className="p-button-warning" name="editar" tooltip="Editar">
                    </Button>
                    : null}
            </div>

            <div className="p-col-12 p-md-6">
                {desarrollador ?
                    <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)}
                        className="p-button-danger" name="eliminar" tooltip="Eliminar">
                    </Button>
                    : null}
            </div>
        </div>;
    }
    mostrarModal = () => {
        this.setState({ mostrarModalActualizarPatron: true, patron: {} });
    }
    mostrarModalEliminar = (rowData) => {

        let patron = JSON.parse(JSON.stringify(rowData));
        this.setState({ patron: patron, mostrarModalConfirmacion: true });
    }
    render() {
        let { desarrollador, paginacion, idsenube, errores, patron, mostrarModalActualizarPatron } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {desarrollador ?
                    <Button className="p-button-secondary" type="button" name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" onClick={this.mostrarModal}></Button>
                    : null}
            </div>
        </div>;
        const pieDialogoPatron = (
            <div>
                <Button icon="pi-md-check" label="Aceptar" onClick={this.guardarPatron} />
                <Button icon="pi-md-close" label="Cancelar" onClick={this.cerrarModal} className="p-button-danger flat-btn" />
            </div>
        );

        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button
                    icon="pi-md-check"
                    onClick={this.eliminar}
                    label="Si estoy seguro"
                />
                <Button
                    icon="pi-md-close"
                    onClick={() =>
                        this.setState({
                            trabajador: {},
                            mostrarModalConfirmacion: false,
                            errores: {},
                        })
                    }
                    label="No estoy seguro"
                    className="p-button-danger flat-btn"
                />
            </div>
        );
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>TABLA IMSS TRABAJADOR</h1>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} header="TABLA IMSS TRABAJADOR" responsive={true} resizableColumns={true} >
                                <Column field="fechaVigente" header="FECHA VIGENTE" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaExcedente} header="EXCEDENTE" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaPrestacionDinero} header="PRESTACIONES EN DINERO" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaGastosMedicosPensionados} header="GASTOS MEDICOS PENSIONADOS" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaInvalidezVida} header="INVALIDEZ Y VIDA" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaCesantiaEdadAvanzadaVejez} header="CESANTIA EN EDAD AVANZADA Y VEJEZ" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                {desarrollador ?<Column body={this.plantillaOpciones} header="OPCIONES" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />: null}
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                        <Dialog appendTo={document.body} header="Actualizar Tabla Imss Patrón" visible={mostrarModalActualizarPatron}
                            modal={true} onHide={this.cerrarModal} footer={pieDialogoPatron}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.fechaVigente"><strong>Fecha Vigente:</strong></label>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <InputText   keyfilter={DEFAULT_MASKS.money} type="text" id="patron.fechaVigente" name="patron.fechaVigente"
                                        value={patron.fechaVigente || ""} className={errores.fechaVigente ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.fechaVigente ? <Message severity="error" text={errores.fechaVigente} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.excedente"><strong>Excedente:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="patron.excedente" name="patron.excedente"
                                        value={patron.excedente || ""} className={errores.excedente ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.excedente ? <Message severity="error" text={errores.excedente} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.prestacionDinero"><strong>Prestaciones en dinero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="patron.prestacionDinero" name="patron.prestacionDinero"
                                        value={patron.prestacionDinero || ""} className={errores.prestacionDinero ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.prestacionDinero ? <Message severity="error" text={errores.prestacionDinero} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.gastosMedicosPensionados"><strong>Gastos Medicos Pensionados:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="patron.gastosMedicosPensionados" name="patron.gastosMedicosPensionados"
                                        value={patron.gastosMedicosPensionados || ""} className={errores.gastosMedicosPensionados ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.gastosMedicosPensionados ? <Message severity="error" text={errores.gastosMedicosPensionados} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.invalidezVida"><strong>Invalidez y Vida:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="patron.invalidezVida" name="patron.invalidezVida"
                                        value={patron.invalidezVida || ""} className={errores.invalidezVida ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.invalidezVida ? <Message severity="error" text={errores.invalidezVida} /> : null}
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label htmlFor="patron.cesantiaEdadAvanzadaVejez"><strong>Cesantia en edad avanzada y vejez:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <InputText  keyfilter={DEFAULT_MASKS.money} type="text" id="patron.cesantiaEdadAvanzadaVejez" name="patron.cesantiaEdadAvanzadaVejez"
                                        value={patron.cesantiaEdadAvanzadaVejez || ""} className={errores.cesantiaEdadAvanzadaVejez ? "p-error" : ""}
                                        onChange={(e) => { this.asignarValores(e, false) }} />
                                    {errores.cesantiaEdadAvanzadaVejez ? <Message severity="error" text={errores.cesantiaEdadAvanzadaVejez} /> : null}
                                </div>
                            </div>
                        </Dialog>
                        <Dialog
                            header="Confirmación"
                            visible={this.state.mostrarModalConfirmacion}
                            modal={true}
                            style={{ width: "30vw" }}
                            footer={dialogFooterConfirmacionEliminar}
                            onHide={() =>
                                this.setState({
                                    cliente: {},
                                    mostrarModalConfirmacion: false,
                                    errores: {},
                                })
                            }
                        >
                            <h2>¿Estás seguro de eliminar la información?</h2>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}